import { Button } from '@/components/Elements';
import Layout from '@/features/reservation/components/Layout';
import { Box, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router';

interface MedicalInterviewCompletedPageProps {
  facilityName: string;
  onError?: boolean;
}

// 事前問診回答後画面
export const MedicalInterviewCompletedPage = ({ facilityName, onError }: MedicalInterviewCompletedPageProps) => {
  const navigate = useNavigate();
  const title = onError ? '問診回答エラー' : 'ご回答ありがとうございました';
  const detail = onError
    ? 'すでに事前問診にご回答いただいております。\n修正がある場合は、ご来院頂いた際、\nスタッフにお申し付けください。'
    : '事前問診の回答が完了しました。\n受信当日はTOP画面またはLINEトーク画面の\nメニューからQRコードを表示し、\n受付をお願いいたします。';
  const buttonText = 'TOPへ戻る';
  return (
    <Layout title={facilityName} backButton={onError}>
      <Box sx={{ margin: 'auto', px: 3, pt: 6 }}>
        <Typography className="text-lg text-center font-bold">{title}</Typography>
        <Box sx={{ margin: 'auto', px: 2, py: 1 }}>
          <Typography sx={{ whiteSpace: 'pre-line' }} className="text-sm/6 pt-6 text-left white-space text-center">
            {detail}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ margin: 'auto', px: 2, py: 1, width: '95%' }}>
          <Button
            className="w-full h-auto mx-auto my-2 py-3 bg-primary text-sm text-white font-semibold"
            onClick={() => {
              navigate('/patient/top');
            }}
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};
